import {
  Legend,
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import type { MarketingStrategy } from '@/types';
import {
  STRATEGY_CHART_COLORS,
  buildMarketProfileRadarData,
  hasAnyMarketProfileSignal,
  strategyChartTooltipProps,
} from './strategy-chart-shared';

export interface StrategyMarketProfileRadarProps {
  strategy: MarketingStrategy;
  compact?: boolean;
}

export function StrategyMarketProfileRadar({ strategy, compact }: StrategyMarketProfileRadarProps) {
  if (!hasAnyMarketProfileSignal(strategy)) return null;

  const data = buildMarketProfileRadarData(strategy);

  return (
    <div className="w-full" style={{ height: compact ? 240 : 280 }}>
      <p className="mb-1 text-xs font-medium text-muted">
        Ausrichtung (aus Strategiedaten, indikativ)
      </p>
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart
          cx="50%"
          cy="50%"
          outerRadius={compact ? '70%' : '76%'}
          data={data}
          margin={compact ? { top: 12, right: 24, bottom: 28, left: 24 } : { top: 16, right: 32, bottom: 36, left: 32 }}
        >
          <PolarGrid className="stroke-primary-foreground dark:stroke-muted" />
          <PolarAngleAxis
            dataKey="axis"
            tick={{ fontSize: compact ? 9 : 11 }}
            className="fill-muted "
          />
          <PolarRadiusAxis angle={30} domain={[0, 100]} tick={{ fontSize: 9 }} className="fill-muted" />
          <Tooltip
            {...strategyChartTooltipProps}
            formatter={(value: number) => [`${value} / 100`, 'Score']}
            labelFormatter={(_, payload) => {
              const p = payload?.[0]?.payload as { axis?: string } | undefined;
              return p?.axis ?? '';
            }}
          />
          <Legend wrapperStyle={{ fontSize: compact ? 10 : 12 }} />
          <Radar
            name="Struktur-Profil"
            dataKey="value"
            stroke={STRATEGY_CHART_COLORS[0]}
            fill={STRATEGY_CHART_COLORS[0]}
            fillOpacity={0.35}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
